import type { FileUploadPurpose } from '@psp-aggregator/sdk';
import { sdkAxios } from '@psp-aggregator/sdk';

export const uploadProviderFiles = async (
  purpose: FileUploadPurpose,
  files: readonly File[],
): Promise<string[]> => {
  const body = new FormData();

  body.append('purpose', purpose);

  for (const file of files) {
    body.append('files', file);
  }

  const { data } = await sdkAxios.post<string[]>('/admin/files', body);

  return data;
};
